import { render, staticRenderFns } from "./HomePlatformStatistics.vue?vue&type=template&id=06946eb7"
import script from "./HomePlatformStatistics.vue?vue&type=script&lang=js"
export * from "./HomePlatformStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports